import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { RedisQueryResultCache } from "./RedisQueryResultCache";
import { DbQueryResultCache } from "./DbQueryResultCache";
import { TypeORMError } from "../error/TypeORMError";
/**
 * Caches query result into Redis database.
 */
export var QueryResultCacheFactory = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function QueryResultCacheFactory(connection) {
    _classCallCheck(this, QueryResultCacheFactory);
    this.connection = connection;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Creates a new query result cache based on connection options.
   */
  _createClass(QueryResultCacheFactory, [{
    key: "create",
    value: function create() {
      if (!this.connection.options.cache) throw new TypeORMError("To use cache you need to enable it in connection options by setting cache: true or providing some caching options. Example: { host: ..., username: ..., cache: true }");
      var cache = this.connection.options.cache;
      if (cache.provider && typeof cache.provider === "function") {
        return cache.provider(this.connection);
      }
      if (cache.type === "redis" || cache.type === "ioredis" || cache.type === "ioredis/cluster") {
        return new RedisQueryResultCache(this.connection, cache.type);
      } else {
        return new DbQueryResultCache(this.connection);
      }
    }
  }]);
  return QueryResultCacheFactory;
}();